(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  // Variável para evitar múltiplas requisições rápidas (Debounce)
  let updateTimeout;

  function initCartPage() {
    initQuantityButtons();
    initAddToCartButtons();
    initFBTSliders();
  }

  function initQuantityButtons() {
    document.querySelectorAll('.btn-increment, .btn-decrement').forEach(button => {
      // Removemos listeners antigos para evitar duplicidade
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const input = this.parentElement.querySelector('.cart__qty-input');
        if (!input) return;
        
        // Pegamos a chave única do item (mais seguro que linha)
        const itemKey = this.getAttribute('data-item-key');
        const index = input.getAttribute('data-index');
        
        let currentQuantity = parseInt(input.value);
        const isIncrement = this.classList.contains('btn-increment');
        
        if (isIncrement) {
          currentQuantity += 1;
        } else if (currentQuantity > 1) {
          currentQuantity -= 1;
        } else {
          return;
        }
       
        // 1. Atualização Visual Imediata (Espelhos Desktop/Mobile)
        const allInputs = document.querySelectorAll(`.cart__qty-input[data-index="${index}"]`);
        allInputs.forEach(el => el.value = currentQuantity);
        
        // 2. Enviar para o Shopify (com atraso para evitar erros de cliques rápidos)
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => {
            updateCartQuantity(itemKey, currentQuantity, index);
        }, 300);
      });
    });
  }

  function initAddToCartButtons() {
    document.querySelectorAll('.add-to-cart-btn').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const variantId = this.getAttribute('data-variant-id');
        const originalText = this.textContent;
        
        this.textContent = 'Adding...';
        this.disabled = true;
        this.style.backgroundColor = '#ccc';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.id) {
            this.closest('.frequently-bought-item').style.display = 'none';
            updateCartCount();
            showNotification('Product added to cart!', 'success');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
             throw new Error('Product not added');
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          showNotification('Error adding product', 'error');
          this.textContent = originalText;
          this.disabled = false;
          this.style.backgroundColor = '#16D6F5';
        });
      });
    });
  }

  function updateCartQuantity(key, quantity, index) {
    // Mostra que está carregando (opcional, muda opacidade)
    const row = document.querySelector(`.line${parseInt(index) + 1}`);
    if(row) row.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
          id: key, 
          quantity: quantity 
      })
    })
    .then(response => response.json())
    .then(data => {
      if(row) row.style.opacity = '1';

      if (data.items) {
        // A. Atualiza Subtotal Geral
        const subtotalElement = document.querySelector('#bk-cart-subtotal-price');
        if (subtotalElement) {
            let subtotal = data.total_price;
            if (!subtotal && data.items_subtotal_price) {
                subtotal = data.items_subtotal_price;
            }
            subtotalElement.textContent = formatMoney(subtotal);
        }
        
        // B. Encontra o item correto na resposta do servidor
        // Precisamos achar o item que corresponde a chave que enviamos
        const updatedItem = data.items.find(item => item.key === key || item.variant_id === key);

        if (updatedItem) {
             // Atualiza Preço da Linha (Desktop e Mobile)
             const priceElements = document.querySelectorAll(`.line-item-price[data-index="${index}"]`);
             priceElements.forEach(el => {
                 el.textContent = formatMoney(updatedItem.final_line_price || updatedItem.line_price);
             });
        } else {
            // Se algo deu errado e o item sumiu (ex: estoque acabou), recarrega
            window.location.reload();
        }
      } else {
          // Se a resposta não for padrão do Shopify
          window.location.reload();
      }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      window.location.reload(); // Fallback de segurança
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) cartCount.textContent = data.item_count;
        if (window.SPMNavbar && typeof window.SPMNavbar.updateCartCount === 'function') {
          window.SPMNavbar.updateCartCount(data.item_count);
        }
      });
  }

  function initFBTSliders() {
    const sliders = document.querySelectorAll('.fbt-slider-wrapper');
    sliders.forEach(sliderWrapper => {
      const sliderId = sliderWrapper.dataset.sliderId;
      const track = sliderWrapper.querySelector('.fbt-slider-track');
      if(!track) return;
      const originalSlides = Array.from(track.querySelectorAll('.fbt-slide:not(.fbt-slide-clone)'));
      
      const container = sliderWrapper.closest('.frequently-bought-together');
      const prevBtn = container.querySelector('.fbt-arrow-prev[data-slider-id="' + sliderId + '"]');
      const nextBtn = container.querySelector('.fbt-arrow-next[data-slider-id="' + sliderId + '"]');
      
      if (originalSlides.length === 0 || !prevBtn || !nextBtn) return;
      
      let currentIndex = 0;
      let slidesToShow = (window.innerWidth <= 768) ? 1 : 2;
      let autoplayInterval = null;
      
      function setupInfiniteLoop() {
        track.querySelectorAll('.fbt-slide-clone').forEach(clone => clone.remove());
        track.style.display = 'flex';
        
        if (originalSlides.length <= slidesToShow) {
          if(container.querySelector('.fbt-arrows-container')) 
             container.querySelector('.fbt-arrows-container').style.display = 'none';
          return;
        }
        
        const clonesNeeded = 2;
        for (let i = 0; i < clonesNeeded; i++) {
          track.appendChild(originalSlides[i].cloneNode(true)).classList.add('fbt-slide-clone');
        }
        for (let i = originalSlides.length - 1; i >= originalSlides.length - clonesNeeded; i--) {
          track.insertBefore(originalSlides[i].cloneNode(true), track.firstChild).classList.add('fbt-slide-clone');
        }
        currentIndex = clonesNeeded;
        updateSliderPosition(false);
      }
      
      function updateSliderPosition(transition = true) {
        track.style.transition = transition ? 'transform 0.5s ease' : 'none';
        const width = track.querySelector('.fbt-slide').offsetWidth + 10; // 10px gap
        track.style.transform = `translateX(-${currentIndex * width}px)`;
      }
      
      function nextSlide() {
        if (originalSlides.length <= slidesToShow) return;
        currentIndex++;
        updateSliderPosition(true);
        if (currentIndex >= originalSlides.length + 2) {
           setTimeout(() => { currentIndex = 2; updateSliderPosition(false); }, 500);
        }
      }

      function prevSlide() {
        if (originalSlides.length <= slidesToShow) return;
        currentIndex--;
        updateSliderPosition(true);
        if (currentIndex < 2) {
           setTimeout(() => { currentIndex = originalSlides.length + 1; updateSliderPosition(false); }, 500);
        }
      }

      nextBtn.addEventListener('click', (e) => { e.preventDefault(); nextSlide(); });
      prevBtn.addEventListener('click', (e) => { e.preventDefault(); prevSlide(); });
      
      window.addEventListener('resize', () => {
         slidesToShow = (window.innerWidth <= 768) ? 1 : 2;
         setupInfiniteLoop();
      });

      setupInfiniteLoop();
    });
  }

  function showNotification(message, type) {
    const div = document.createElement('div');
    div.style.cssText = `position: fixed; top: 20px; right: 20px; padding: 15px; background: ${type === 'success' ? '#4caf50' : '#f44336'}; color: #fff; border-radius: 4px; z-index: 9999;`;
    div.textContent = message;
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 3000);
  }

  function formatMoney(cents) {
    if (cents == null) return '$0.00';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

})();